export * from './environment.prod';






// WEBPACK FOOTER //
// ./src/app/environments/index.ts